module.exports = __webpack_public_path__ + "static/img/hy_android.ab28b9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy_android.jpg
// module id = uDnG
// module chunks = 0